import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { useTypedSelector } from '@/store/store';
import {
  selectProductPostListResource,
  selectProductRelationListResource,
  selectProductResource,
} from '@/store/reducers/pages/product/product';
import { getAliasString } from '@/utils/common';
import BreadCrumb from '@/components/BreadCrumb';
import { BreadCrumbType } from '@/typings/common';
import ContentContainer from '@/components/ContentContainer';
import { colors } from '@/constants/theme';

function Header() {
  const router = useRouter();
  const alias = getAliasString(router.query.alias);

  const { data: product } = useTypedSelector((state) => {
    return selectProductResource(state, alias);
  });

  const breadCrumbList: BreadCrumbType[] = [];
  if (product && product.breadcrumbs) {
    product.breadcrumbs.map((item) =>
      breadCrumbList.push({
        label: item.name,
        url: item.link,
      })
    );
    breadCrumbList.push({
      label: product.name,
    });
  }
  return (
    <Component>
      <ContentContainer>
        <Content>
          <BreadCrumb breadCrumbs={breadCrumbList} />
          <Name>{product?.name ?? ''}</Name>
          <Subcontent>
            <Subtitle>{product?.subtitle ?? ''}</Subtitle>
          </Subcontent>
        </Content>
      </ContentContainer>
    </Component>
  );
}

export default Header;

const Component = styled.div`
  margin-top: 5px;
`;
const Content = styled.div``;
const Name = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
`;

const Subcontent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const Subtitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: ${colors.gray300};
`;

const Code = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: ${colors.black};
`;

const Index = styled.span`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: ${colors.black};
`;
